export default {
      id: "icon-chevron-down-usage",
      viewBox: "0 0 14 9",
      url: "../icon/" + "icons.svg#icon-chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }